export default "__VITE_ASSET__DiM0wcFi__"